import { ArrowBackIcon } from '@pmi/dsm-react/dist/components/icons/fa/24';
import { SortDirection } from '../models';
import styles from './header.module.scss';

interface HeaderSortProps {
  direction: SortDirection;
}

export default function HeaderSort({ direction }: HeaderSortProps) {
  return (
    <div className="d-flex flex-row">
      {direction === 'Asc' || direction === undefined ? (
        <ArrowBackIcon fontSize="sm" className={styles.iconUp} />
      ) : null}
      {direction === 'Desc' || direction === undefined ? (
        <ArrowBackIcon fontSize="sm" className={styles.iconDown} />
      ) : null}
    </div>
  );
}
